import React from "react";
import ContactFormHealthScreening from "../../global/contactFormHealthScreening";

const renderComponent = component => {
  switch (component.formType) {
    case "healthScreening":
      return <ContactFormHealthScreening content={component} />;
    default:
      return null;
  }
};

export default function PageSection({ component }) {
  return renderComponent(component);
}
